import React, { Component } from 'react';
import { HashRouter, Route, withRouter, Switch } from 'react-router-dom';
import routes from './routes';
import NotFound from '../components/Pages/NotFound';
import RegisterContainer from '../components/Pages/Register';
import { AuthRoute } from './AuthRoute';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import permissionsActions from '../actions/permissions.actions';
import { bindActionCreators } from 'redux';
import { generalActions } from '../actions/general.action';
import { store } from '../utils/store';
import { actionConstants } from '../actions/actionConstants';
import { accountActions } from '../actions/account.action';

const registerPath =
  '/register/:invitationId([a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12})';
const period = 6000; //1 minute

class AppNavigation extends React.Component {
  constructor(props) {
    super(props);
    const { i18n } = this.props;
    const language = localStorage.getItem('language') || 'en_US';
    i18n.changeLanguage(language);
    this.state = { loading: false, checkingSessionInterval: null };
    this.isExpired = false;
  }
  sessionTimeout = () => {
    const checkingExpire = () => {
      const isExpired = this.props.generalActions.checkSession();
      if (isExpired) {
        console.log('session expire ...');
        this.props.history.push('/login');
        return true;
      }
      return false;
    };
    if (this.props.location.pathname !== `/login`) {
      const isSessionInitialized =
        localStorage.getItem('isSessionInitialized') === 'true';
      if (!isSessionInitialized) {
        console.log('session initializing ...');
        this.props.generalActions.initSession();
      } else {
        if (!this.state.checkingSessionInterval) {
          console.log('checking session ...');
          this.isExpired = checkingExpire();
          const checkingSessionInterval = setInterval(() => {
            console.log('checking session intervally ...');
            this.isExpired = checkingExpire();
          }, period);
          this.setState({ checkingSessionInterval });
        }
      }
    } else {
      if (this.state.checkingSessionInterval) {
        console.log('clear interval');
        clearInterval(this.state.checkingSessionInterval);
        this.setState({ checkingSessionInterval: null });
      }
    }
  };
  async componentDidMount() {
    document.title = window.configs.APP_TITLE;
    if (
      this.props.location.pathname !== `/change-password` &&
      this.props.general.isPwdExpired
    ) {
      this.props.history.push('/change-password');
    }
    this.sessionTimeout();
    if (!this.isExpired) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo && userInfo.access_token) {
        this.props.permissionsActions
          .isLoadedCurrentUserPermissions()
          .then((isLoaded) => {
            if (!isLoaded) {
              this.setState(
                { loading: true },
                async () =>
                  await this.props.permissionsActions
                    .getCurrentUserPermissions()
                    .finally(() => this.setState({ loading: false })),
              );
            }
          });
      }
    }
  }
  componentDidUpdate() {
    if (
      this.props.location.pathname !== `/change-password` &&
      this.props.general.isPwdExpired
    ) {
      this.props.history.push('/change-password');
    }
    this.sessionTimeout();
    if (this.props.general.doLogout) {
      store.dispatch({ type: actionConstants.NEED_LOGOUT, data: false });
      this.props.history.push('/login');
    }
  }

  render() {
    return (
      <Switch>
        {routes.map((route, index) => {
          return route.requireAuth ? (
            <AuthRoute
              key={index}
              path={route.path}
              component={route.component}
              exact={route.exact}
              {...route}
              {...this.props}
            />
          ) : (
            <Route
              key={index}
              path={route.path}
              component={route.component}
              exact={route.exact}
            />
          );
        })}
        <Route path={registerPath} component={RegisterContainer} exact />
        <Route component={NotFound} />
      </Switch>
    );
  }
}

function mapStateToProps(state) {
  return {
    permissions: state.permissions,
    general: state.general,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    permissionsActions: bindActionCreators(
      Object.assign({}, permissionsActions),
      dispatch,
    ),
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
    accountActions: bindActionCreators(
      Object.assign({}, accountActions),
      dispatch,
    ),
  };
}

const App = withTranslation('app')(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(AppNavigation)),
);

const AppContainer = () => {
  return (
    <HashRouter basename={window.configs.BASE_URL}>
      <App />
    </HashRouter>
  );
};

export default AppContainer;
